import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';

import './DayCellDropdown.scss';

class DayCellDropdown extends Component {

    constructor(props) {
        super(props);

        this.segmentSelectionChange = this.segmentSelectionChange.bind(this);
    }

    segmentSelectionChange = (event, { value }) => {
        const { updateSegment } = this.props;

        if (value === 'closed') {
            updateSegment({ closed: true, allDay: false });
        } else if (value === 'allDay') {
            updateSegment({ closed: false, allDay: true });
        } else if (value === 'exactHours') {
            updateSegment({ closed: false, allDay: false });
        }
    }

    renderDropdownItems(currentChoice) {
        const chooseHours = [
            {
                text: i18next.t('closed'),
                value: 'closed',
                label: { color: 'red', empty: true, circular: true },
                onClick: this.segmentSelectionChange
            },
            {
                text: i18next.t('allDay'),
                value: 'allDay',
                label: { color: 'green', empty: true, circular: true },
                onClick: this.segmentSelectionChange
            },
            {
                text: i18next.t('exactHours'),
                value: 'exactHours',
                label: { color: 'blue', empty: true, circular: true },
                onClick: this.segmentSelectionChange
            }
        ];

        const dropdownItems = chooseHours.map((option, index) => {
            let description = option.value === currentChoice ? i18next.t('current') : null;
            return (
                <Dropdown.Item key={index} {...option} description={description} />
            );
        });

        return dropdownItems;
    }

    render() {
        const { segment, figureSegmentState } = this.props;

        let cellText;
        let currentChoice = figureSegmentState(segment);

        if (currentChoice === 'closed') {
            cellText = i18next.t('closed');
        } else if (currentChoice === 'allDay') {
            cellText = i18next.t('allDay');
        } else {
            cellText = segment.openTime.substring(0, 5) + '-' + segment.closeTime.substring(0, 5);
        }

        return (
            <Table.Cell
                textAlign='center'
                positive={segment.allDay}
                negative={segment.closed}
                singleLine
                className='pi-week-scheduler-status-cell' >
                <Dropdown
                    icon='dropdown'
                    labeled
                    text={cellText}
                    placeholder={i18next.t('select')}
                    value={currentChoice}
                    onChange={this.segmentSelectionChange} >
                    <Dropdown.Menu>
                        <Dropdown.Header icon='calendar minus' content={i18next.t('chooseHours')} />
                        {this.renderDropdownItems(currentChoice)}
                    </Dropdown.Menu>
                </Dropdown>
            </Table.Cell>
        );
    }
}

DayCellDropdown.propTypes = {
    segment: PropTypes.object,
    figureSegmentState: PropTypes.func,
    updateSegment: PropTypes.func,
    
};

export default DayCellDropdown;